module.exports = __webpack_public_path__ + "media/images/icons/outlined/project-39f69fa7706d3a61d49772a14efdaabe.svg";